import React, { Component } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import PDFIcon from 'Icons/PDFIcon';
import { action } from 'Shared/Routes';
import { b_seminars_config, dashboards_status } from 'Shared/options';
import { isTrue, num, getSpaceAmount, getTotalHTServiceAmount, formatNum } from 'Shared/utilities';
const qwest = window.qwest;
export default class AdminBookingRow extends Component {
  state = {
    loading: false,
    modal: false
  };
  modal_ref = React.createRef();
  openModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal: true,
      modal_trigger: e?.target
    });
  };
  closeModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal: false,
      modal_trigger: undefined
    });
  };
  cancel = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    let url;
    if (props.data.packorder) {
      url = action('cancelCompanyBooking');
    } else {
      url = action('cancelBooking');
    }
    qwest.post(url, {
      id: props.data?.id
    }).then(function (xhr, response) {
      component.setState({
        loading: false
      });
      props.requestUpdate();
      component.modal_ref?.current?.click();
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      data,
      blank = false,
      fields
    } = props;
    numeral.locale('en');
    moment.locale('fr');
    const base_total = num(data.amount);
    const base_services_price = (data.services || []).filter(row => row.payment_type !== 'add-services').reduce(function (total, row) {
      return num(total + num(row.total_price));
    }, 0);
    const services_price = (data.services || []).reduce(function (total, row) {
      if (isTrue(row.canceled)) return total;
      return num(total + num(row.total_price));
    }, 0);
    const discounted = num((data.discount_code || {}).discounted);
    const space_price = num(base_total - base_services_price + discounted);
    const grand_total = num(space_price - discounted + services_price);
    let raw_total = num(space_price / 1.2);
    (data.services || []).filter(row => !isTrue(row.canceled)).forEach(function (row) {
      raw_total += num(num(row.total_price) - num(row.vat_price));
    });
    const status = dashboards_status.find(option => option.value === data.status);
    const disposition = b_seminars_config[data.disposition]?.title ? b_seminars_config[data.disposition].title : '';
    let output = /*#__PURE__*/React.createElement("div", {
      className: !data.packorder ? "c-dashboard__row" : "c-dashboard__row c-dashboard__row--company"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell\r Booking-coworking_space__etablishment_name"
    }, data.coworking_space._etablishment.name), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-created_at"
    }, moment(data.created_at).format('DD/MM/YYYY')), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-date"
    }, moment(data.date).format('DD/MM/YYYY')), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-coworking_space_type"
    }, data.coworking_space.type === 'b_seminar' ? 'Meeting ' + disposition : data.coworking_space.type === 'c_open_coworking_space' ? 'Lib' : 'Lounge'), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-customer_lastname"
    }, [[data.customer.lastname, data.customer.firstname].filter(str => str).join(' '), data.customer.phone_number?.length > 4 ? data.customer.phone_number : undefined].filter(str => str).join(' / ')), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-amount_ht"
    }, formatNum(raw_total, '0,0[.]00') + '€'), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-amount_ttc"
    }, data.packorder ? formatNum(data.amount, '0,0[.]00') : formatNum(grand_total, '0,0[.]00'), data.packorder ? 'crédits' : '€'), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-source"
    }, data.source === 'direct' ? 'Hôtel' : data.source === 'offline' ? "Offline" : 'myWO'), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-status"
    }, status?.label), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-PDF"
    }, !data.packorder ? /*#__PURE__*/React.createElement("a", {
      href: action('getBookingPDF').replace(':booking_id', data.id),
      target: "_blank",
      type: "application/pdf",
      rel: "noopener noreferrer",
      className: "c-dashboard__pdf-link"
    }, /*#__PURE__*/React.createElement(PDFIcon, {
      className: "c-dashboard__pdf-icon"
    })) : undefined));
    return output;
  }
}
